import React, { Component } from 'react';
import { PreviousButton } from '../components/PreviousButton';
import { LenderRow } from '../components/LenderRow';

interface IProps {
    gtmEvent(): void;
    nextStep(s: string): void;
    prevStep(): void;
    updateLead(props: any): void;
    mortgageamount?:number;
    lvretainexistingproperty?:string;
}

interface IState{
    isfirstmortgage?:string;
    lvretainexistingproperty?:string;
}
export class IsFirstMortgage extends Component<IProps, any> {
    constructor (props: IProps) {
        super(props);
        this.state={isfirstmortgage:''}
        this.nextStep = this.nextStep.bind(this);
    }

    componentDidMount(): void {
        this.props.gtmEvent();
    }

    nextStep(response: string) {
        // this.props.updateLead({isFirstMortgage: response === 'yes'});
        // this.props.nextStep(response);
        if(response=='yes'){
            this.props.updateLead({isFirstMortgage: response === 'yes'});
            this.props.nextStep(response);
        }else{
            this.props.updateLead({isFirstMortgage: false});
            this.props.nextStep(response);
        }
    }

    render() {

        return (
            <header className="App-header">
                <h1>Is this your first mortgage?</h1>
                <div className='wrapper'>
                    <div className='row'>
                        <div className='column2 flex-end'>
                            {/* <div className='boxty small' onClick={() => this.nextStep('yes')}> */}
                            <div className={`boxty small ${this.state.isfirstmortgage==='yes'?'selected':''}`} onClick={() => {this.nextStep('yes');this.setState({isfirstmortgage:'yes'})}}>
                                <div><h2 className='btn'>Yes</h2></div>
                            </div>
                        </div>
                        <div className='column2 flex-start'>
                            {/* <div className='boxty small' onClick={() => this.nextStep('no')}> */}
                            <div className={`boxty small ${this.state.isfirstmortgage==='no'?'selected':''}`} onClick={() => {this.nextStep('no');this.setState({isfirstmortgage:'no'})}}>
                                <div><h2 className='btn'>No</h2></div>
                            </div>
                        </div>
                    </div>
                    {/* {this.state.isfirstmortgage==='no' && (<>
                    <h1>Do you plan on retaining your existing property?</h1>
                        <div className='wrapper'>
                            <div className='row'>
                                <div className='column2 flex-end'>
                                    <div className={`boxty small ${this.state.lvretainexistingproperty==='true'?'selected':''}`} onClick={() => {this.setState({lvretainexistingproperty:'true'});this.nextStep('true')}}>
                                        <div><h2 className='btn'>Yes</h2></div>
                                    </div>
                                </div>

                                <div className='column2 flex-start'>
                                    <div className={`boxty small ${this.state.lvretainexistingproperty==='false'?'selected':''}`} onClick={() => {this.setState({lvretainexistingproperty:'false'});this.nextStep('false')}}>
                                        <div><h2 className='btn'>No</h2></div>
                                    </div>
                                </div>
                            </div>                    
                        </div></>)} */}

                    <div className='row'>
                        <div className='button-group'>
                            <PreviousButton onClick={() => this.props.prevStep()} />
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <LenderRow />
                    </div>

                </div>
            </header>
        );
    }
}
